module.exports = __webpack_public_path__ + "img/q6.d2171d0b.jpg";